/**
 * Shim for shared-components/analytics-integrations/analytics-utils.js
 *
 * The original uses `!!analytics` as a bare global reference, which throws
 * ReferenceError when Segment's analytics.js hasn't loaded (e.g. Vite dev build).
 * This shim replaces it with a typeof guard so it returns false instead of throwing.
 */

const sharedAnalyticsIntegrations = {};

sharedAnalyticsIntegrations.isMobile = (iPhoneOnly, excludeTablet, customUserAgentData) => {
  var agentStyles;
  if (customUserAgentData || global.navigator) {
    if (iPhoneOnly) {
      agentStyles = /iPhone/i.test(customUserAgentData || global.navigator.userAgent);
    } else if (excludeTablet) {
      agentStyles = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || navigator.userAgent);
    } else {
      agentStyles = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(customUserAgentData || global.navigator.userAgent);
    }
  }
  var isMobile = agentStyles;
  return isMobile;
};

// checks segment state — window.analytics.initialize is set by Segment after it fully loads;
// the pre-load stub is a plain array (no initialize property), so this correctly returns
// false until the real Segment script has run.
sharedAnalyticsIntegrations.segmentLoaded = () => {
  return !!(window.analytics && window.analytics.initialize);
};

export default sharedAnalyticsIntegrations;
